export default __webpack_public_path__ + "static/media/i_bus-jeonse_yl.71135d8b.svg";